import { Calculator } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCalculator = mkIcon(Calculator);
